import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OsCommandService {

  numberDisplayMode: 'dec' | 'hex' = 'dec';

}
